/**
 * The few words beside a stored reply's actions when it did not end as it
 * should. Pure, so it is tested.
 */

import type { Message } from '../api';

/** Null for a reply that ended, or one waiting on a tool or on the person to
 *  go on: it has not stopped, it is waiting. A failure Assist kept says what
 *  the person was told when it happened. */
export function replyNote(message: Message): string | null {
  const b = message.body;
  if (b.kind !== 'text' || b.pending?.length || b.stepLimit) return null;
  if (message.status === 'partial') return 'Stopped';
  if (message.status === 'error') return b.failure ?? 'Did not finish';
  return null;
}
